import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { Card, AdvancedTable, CustomRadio } from 'components';
import { useLocalErrorHandler } from 'hooks';
import styles from './EcExpertsContainer.module.scss';
import cn from 'classnames';

const EcExpertsContainer = ({
    setErrorHandler,
    fetchExpertsList,
    expertsList,
    onPush,
    apiError,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [sortOrder, setSortOrder] = React.useState(true);
    const [filter, setFilter] = React.useState('all');

    React.useEffect(() => {
        const fetch = async () => {
            await fetchExpertsList({ onlyQecEmployees: filter === 'employer' });
        };

        fetch();
    }, [filter]);

    const createTableData = expertsList && expertsList.items.map(({
        id, phone, firstName, lastName, middleName, email, region,
    }) => ({
        id,
        columns: [
            `${lastName} ${firstName} ${middleName}`,
            phone,
            email,
            region,
        ],
    }));

    const applicationsHeader = [
        { fieldName: 'fullName', title: 'ФАМИЛИЯ, ИМЯ, ОТЧЕСТВО' },
        { fieldName: 'phone', title: 'Телефон' },
        { fieldName: 'email', title: 'Почта' },
        { fieldName: 'region', title: 'Регион' },
    ];

    const handleExpertSelect = (expertId: string) => onPush(`/expert/${expertId}`);
    const handleSearch = (fieldName: string, value: string) => fetchExpertsList({ searchField: fieldName, searchTerm: value, onlyQecEmployees: filter === 'employer' });
    const handleOrder = (fieldName: string) => {
        setSortOrder(!sortOrder);
        fetchExpertsList({ sortField: fieldName, sortOrder, onlyQecEmployees: filter === 'employer' });
    };

    return (
        <Card
          title="Эксперты ЭЦ"
          category="Список экспертов, сотрудничающих с ЭЦ"
          apiError={apiError}
          withoutPadding
        >
            <div className={cn('d-flex mb-5', styles.filterBtnContainer)}>
                <CustomRadio
                  label="Все"
                  name="expert-filter"
                  option="all"
                  checked={filter === 'all'}
                  onClick={() => setFilter('all')}
                />
                <CustomRadio
                  label="Сотрудники ЭЦ"
                  name="expert-filter"
                  className="ml-3"
                  option="employer"
                  checked={filter === 'employer'}
                  onClick={() => setFilter('employer')}
                />
            </div>
            <AdvancedTable
              data={createTableData || []}
              tableHeaders={applicationsHeader}
              handlePageChange={({ page, perPage }) => fetchExpertsList({ pageSize: perPage, page })}
              handleSearch={handleSearch}
              handleOrder={handleOrder}
              handleRowClick={handleExpertSelect}
              page={(expertsList && expertsList.page) || 1}
              pageSize={(expertsList && expertsList.pageSize) || 10}
              total={(expertsList && expertsList.total) || 1}
              placeholderTitle="Нет поданных заявок"
              placeholderText="Здесь будут отображаться все заявки от соискателей, которые требуют обработки "
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    expertsList: state.experts.expertsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    fetchExpertsList: dispatch.experts.getExpertsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
type Props = connectedProps;

export default connect(mapState, mapDispatch)(EcExpertsContainer);
